import React, { useCallback, useEffect, useState } from 'react'
import { useFeatureIsOn, useFeatureValue } from '@growthbook/growthbook-react'
import { Col, Dropdown, Menu, message, notification, Row, Space, Spin } from 'antd'
import {
  ColumnsAndRowsSelections,
  DownloadModal,
  FavouriteEditModal,
  PreferencesTableModal,
  ProgressBar,
  SelectType,
} from 'modules/core/components'
import { GENERAL, INTEGRATIONS } from 'modules/core/constants'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Prompt, useParams } from 'react-router-dom'
import {
  handleSave,
  handleSavePrimary,
} from 'modules/control/containers/ControlDetail/components/Evolution/utils'
import { EvolutionTable } from './components'
import { CommentOutlined } from '@ant-design/icons'
import { handleEditFinancial } from './utils/helper'
import TableActions from '../TableActions/TableActions'
import login from 'modules/login'
import reports from 'modules/reports'
import configuration from 'modules/configuration'
import control from 'modules/control'
import moment from 'moment/moment'
import _, { isEqual } from 'lodash'
import { handleDelete } from '../../utils'
import {
  generateMessageError,
  getHashTable,
  sendUserDataToGTM,
  setFormatNumber,
} from 'modules/core/utils'

import PivotTableUX from 'components/PivotTable/PivotTableUX'
import PivotTableRenderers from 'components/PivotTable/Renderers/Evolution/Tree'

import PlaneTableUX from 'components/PivotTable/PlaneTableUX'
import PlaneTableRenderers from 'components/PivotTable/Renderers/Evolution/Plane'
import ReportChart from '../../../ReportChart/ReportChart'

const DEFAULT_FORMAT_CREATE = {
  'Suma (Decimales)': 'float',
  'Suma (Enteros)': 'int',
  'Suma (Miles)': 't',
  'Suma (Millones)': 'm',
}

const DEFAULT_FORMAT_SET = {
  float: 'Suma (Decimales)',
  int: 'Suma (Enteros)',
  t: 'Suma (Miles)',
  m: 'Suma (Millones)',
}

const getRowAuxName = (rows, allDimensionsList) => {
  return rows.map((row) => {
    if (row === 'Linea de reporte') {
      return 'Linea de reporte'
    } else if (row === 'Fecha') {
      return 'Fecha'
    } else if (row === 'Moneda Origen') {
      return 'Moneda Origen'
    } else {
      const dimension = allDimensionsList.find((el) => parseInt(row) === el.id)
      return dimension ? dimension.name_origin : ''
    }
  })
}

const getColsAuxName = (columns, allDimensionsList) => {
  return columns.map((col) => {
    if (col === 'Linea de reporte') {
      return 'Linea de reporte'
    } else if (col === 'Fecha') {
      return 'Fecha'
    } else if (col === 'Moneda Origen') {
      return 'Moneda Origen'
    } else {
      const dimension = allDimensionsList.find((el) => parseInt(col) === el.id)
      return dimension ? dimension.name_origin : ''
    }
  })
}

const getRowAuxId = (settings, allDimensionsList) => {
  return (
    !_.isEmpty(settings) &&
    settings.rows.map((row) => {
      if (row === 'Linea de reporte') {
        return 'Linea de reporte'
      } else if (row === 'Fecha') {
        return 'Fecha'
      } else if (row === 'Moneda Origen') {
        return 'Moneda Origen'
      } else {
        const id = allDimensionsList.find((el) => el.name_origin === row).id
        return id.toString()
      }
    })
  )
}

const getColsAuxId = (settings, allDimensionsList) => {
  return (
    !_.isEmpty(settings) &&
    settings.cols.map((col) => {
      const id = allDimensionsList.find((el) => el.name_origin === col)
        ? allDimensionsList.find((el) => el.name_origin === col).id
        : null
      if (col === 'Linea de reporte') {
        return 'Linea de reporte'
      } else if (col === 'Fecha') {
        return 'Fecha'
      } else if (col === 'Moneda Origen') {
        return 'Moneda Origen'
      } else {
        return id.toString()
      }
    })
  )
}

const Evolution = ({
  loading,
  selectedFilters,
  selectedDates,
  selectedPeriod,
  groupProjection,
  periodTableSettings,
  setPeriodTableSettings,
  selectedProjection,
  setSelectedProjection,
  setTablePagination,
  tablePagination,
  onRefetch,
  dataTableEvolution: { columns, rows },
  downloadEvolutionXLS,
  loggedUser,
  reportStructure,
  lineVertical,
  setLineVertical,
  onRefetchEvolution,
  setDataComments,
  dataComments,
  onRefetchComments,
  loadingComments,
  commentKey,
  dataEvolutionReport,
  fetchLayoutList,
  layoutList,
  fetchAllDimensions,
  allDimensionsList,
  createLayout,
  updatedInitialAmountByFinancial,
  deleteLayout,
  hasComment,
  setHasComment,
  createComment,
  removeNewComment,
  isProgressLoading,
  showProgressBar,
  currencyData,
  dataEvolutionChart,
  lineId,
  isLoadingGraphAndKpi,
  getDataGraphByReport,
  reportChartData,
  tabKey,
  type,
  showTableqp,
  setShowTableqp,
  setBaseSelect,
  exist,
  setExist,
  settings,
  setSettings,
}) => {
  // Feature flag
  const enabledEvolutionTable = useFeatureIsOn('feature-react-pivot-evolution')
  const enabledPlaneTable = useFeatureIsOn('feature-plane-table-custom')
  const enableFormatNumber = useFeatureIsOn('enable-format-number')
  const formatBaseNumber = useFeatureValue('format-number-table', 'Suma (Decimales)')
  const enabled = useFeatureIsOn('feature-react-pivot-evolution')

  // Hooks
  const { t } = useTranslation()
  let { reportId, periodId } = useParams()

  // State
  const [periodTableColumns, setPeriodTableColumns] = useState([])
  const [showModal, setShowModal] = useState(false)
  const [editFilter, setEditFilters] = useState({})
  const [showPopover, setShowPopover] = useState(false)
  const [favouriteName, setFavouriteName] = useState('')
  const [isSaving, setIsSaving] = useState(false)
  const [isLayoutLoading, setIsLayoutLoading] = useState(false)
  const [viewSelect, setViewSelect] = useState({})
  const [viewComment, setViewComment] = useState(false)
  const [showEdit, setShowEdit] = useState(false)
  const [showModalEdit, setShowModalEdit] = useState(false)
  const [newName, setNewName] = useState('')
  const [rowId, setRowId] = useState(null)
  const [hash, setHash] = useState(null)
  const [showPreferenceModal, setShowPreferenceModal] = useState(false)
  const [dataLocalStorage, setDataLocalStorage] = useState(localStorage.getItem('dataTable'))

  // Values
  const { dataSource, fields, linesOrder, linesTotal, linesRatio, linesRatioN, linesFinancial } =
    dataEvolutionReport
  const linesReport = reportStructure?.values.filter((item) =>
    ['grouper', 'totalizer'].includes(item.type),
  )
  let inputValue = null

  const paramsDownload = {
    period_id: periodId,
    filter_date: selectedDates,
    filter: selectedFilters,
    type_report: selectedProjection,
  }
  const params = {
    step: null,
    type_table: 'report',
    report_id: reportId,
  }

  var queryString = window.location.search
  var urlParams = new URLSearchParams(queryString)
  var table = urlParams.get('table')
  var reportLine = urlParams.get('reportLine')
  var url_hash = urlParams.get('hash_url')

  useEffect(() => {
    const onCustom = (e) => {
      if (e?.detail?.key === 'dataTable') setDataLocalStorage(e.detail.value)
    }

    window.addEventListener('local-storage', onCustom)
    return () => {
      window.removeEventListener('local-storage', onCustom)
    }
  }, [])

  useEffect(() => {
    if (!dataLocalStorage && !url_hash && layoutList.values.length === 0) {
      setSettings({})
    }

    const dataTable = JSON.parse(dataLocalStorage)

    if (dataLocalStorage && allDimensionsList.length > 0) {
      setSettings((prevstate) => {
        return {
          ...prevstate,
          ...dataTable[tabKey],
          hiddenFromDragDrop: ['amount', 'price', 'quantity'],
        }
      })

      const dataFormat = dataTable[tabKey]
        ? {
            row_order: 0,
            column_order: 1,
            default_value: dataTable[tabKey].vals[0],
            default_format: DEFAULT_FORMAT_CREATE[dataTable[tabKey].aggregatorName],
            rows: getRowAuxId(dataTable[tabKey], allDimensionsList),
            columns: getColsAuxId(dataTable[tabKey], allDimensionsList),
          }
        : {}

      const data = layoutList.values
        .filter((el) => !el.url_hash)
        .find((el) => _.isEqual(el.config, dataFormat))

      if (data) {
        setExist(true)
        setViewSelect(data)
      } else {
        setExist(false)
        const aux = layoutList.values.filter((el) => !el.url_hash).find((el) => el.primary)
        setViewSelect(aux)
      }
    }

    const layoutsUrlHash = layoutList.values.filter((el) => el.url_hash)

    if (
      url_hash &&
      !dataTable[tabKey] &&
      layoutsUrlHash.length > 0 &&
      allDimensionsList.length > 0
    ) {
      setSettings((prevstate) => {
        return {
          ...prevstate,
          ...layoutsUrlHash[0].config,
          hiddenFromDragDrop: ['amount', 'price', 'quantity'],
        }
      })

      const dataFormat = {
        row_order: 0,
        column_order: 1,
        default_value: layoutsUrlHash[0].config.vals[0],
        default_format: DEFAULT_FORMAT_CREATE[layoutsUrlHash[0].config.aggregatorName],
        rows: getRowAuxId(layoutsUrlHash[0].config, allDimensionsList),
        columns: getColsAuxId(layoutsUrlHash[0].config, allDimensionsList),
      }

      const data2 = layoutList.values
        .filter((el) => !el.url_hash)
        .find((el) => _.isEqual(el.config, dataFormat))

      if (data2) {
        setViewSelect(data2)
        setExist(true)
      } else {
        setExist(false)
        const aux = layoutList.values.filter((el) => !el.url_hash).find((el) => el.primary)
        setViewSelect(aux)
      }
    }
  }, [dataLocalStorage, allDimensionsList, url_hash, tabKey, layoutList.values])

  useEffect(() => {
    if (table) {
      const data = !isEqual(hash, table) && hash !== null ? hash : table
      const json = Buffer.from(data, 'base64').toString()
      const dataTable = JSON.parse(json)
      setSettings((prevstate) => {
        return {
          ...prevstate,
          ...dataTable.config,
          hiddenFromDragDrop: ['amount', 'price', 'quantity'],
        }
      })
    }
  }, [table, hash])

  useEffect(() => {
    const { data, hiddenFromDragDrop, tableOptions, ...restProps } = settings
    if (!_.isEmpty(restProps) && showTableqp) {
      window.history.replaceState(
        null,
        '',
        `/analisis/${periodId}/reportesplika/${reportId}/${type}/${currencyData?.id}/${tabKey}/${
          selectedProjection.id
            ? `${selectedProjection.value}-${selectedProjection.id}`
            : selectedProjection.value
        }${reportLine ? `?reportLine=${reportLine}` : ''}${reportLine ? '&' : '?'}`, //table=${getHashTable(settings)}`,
      )
    }
  }, [
    settings,
    periodId,
    reportId,
    type,
    tabKey,
    currencyData,
    selectedProjection,
    showTableqp,
    reportLine,
  ])

  // Methods
  useEffect(() => {
    setPeriodTableColumns(columns)
  }, [columns])

  useEffect(() => {
    fetchAllDimensions()
  }, [fetchAllDimensions])

  useEffect(() => {
    setIsLayoutLoading(true)
    const endpointParam = { ...(url_hash && { url_hash }) }
    fetchLayoutList('reports', `${periodId}-${reportId}-montly_evolution`, endpointParam).then(
      () => {
        setIsLayoutLoading(false)
        // !table && setSettings({})
      },
    )
  }, [fetchLayoutList, periodId, reportId, table, url_hash])

  useEffect(() => {
    const defaultLayout = layoutList.values.filter((el) => !el.url_hash).find((el) => el.primary)
    if (!dataLocalStorage) {
      setViewSelect(defaultLayout)
    }
  }, [layoutList.values, dataLocalStorage])

  useEffect(() => {
    if (
      layoutList.values.filter((el) => !el.url_hash).length > 0 &&
      !_.isEmpty(viewSelect) &&
      allDimensionsList.length > 0 &&
      !table &&
      !url_hash &&
      !localStorage.getItem('dataTable')
    ) {
      setSettings((prevState) => {
        return {
          ...prevState,
          ...viewSelect.config,
          hiddenFromDragDrop: ['amount', 'price', 'quantity'],
          cols:
            getColsAuxName(viewSelect.config.columns, allDimensionsList).length > 0
              ? getColsAuxName(viewSelect.config.columns, allDimensionsList)
              : ['date'],
          rows: getRowAuxName(viewSelect.config.rows, allDimensionsList),
          aggregatorName: DEFAULT_FORMAT_SET[viewSelect.config.default_format],
          vals: [viewSelect.config.default_value],
        }
      })
    }
  }, [allDimensionsList, layoutList.values, viewSelect, table, url_hash])

  const onClose = () => {
    setIsSaving(false)
    setShowPopover(false)
    setFavouriteName('')
  }

  const onCreate = () => {
    const data = {
      row_order: 0,
      column_order: 1,
      default_value: settings.vals[0],
      default_format: DEFAULT_FORMAT_CREATE[settings.aggregatorName],
      rows: getRowAuxId(settings, allDimensionsList),
      columns: getColsAuxId(settings, allDimensionsList),
    }

    return createLayout('reports', `${periodId}-${reportId}-montly_evolution`, favouriteName, {
      config: data,
    })
  }

  const defaultData = !_.isEmpty(viewSelect) && {
    ...viewSelect.config,
    rows: getRowAuxName(viewSelect.config.rows, allDimensionsList),
    columns: getColsAuxName(viewSelect.config.columns, allDimensionsList),
    default_format: DEFAULT_FORMAT_SET[viewSelect.config.default_format],
  }
  const defaultSettings = !_.isEmpty(settings) && {
    rows: settings.rows,
    columns: settings.cols || ['Fecha'],
    row_order: settings.row_order,
    column_order: settings.column_order,
    default_value: settings.vals ? settings.vals[0] : '',
    default_format: settings.aggregatorName,
  }

  const onSavePrimary = (data) => {
    const dataAux = layoutList.values
      .filter((el) => !el.url_hash)
      .find((el) => el.name === data.name)
    return createLayout('reports', `${periodId}-${reportId}-montly_evolution`, dataAux.name, {
      ...dataAux,
      primary: true,
    })
  }

  useEffect(() => {
    setSettings((prevState) => ({
      ...prevState,
      data: dataEvolutionReport.dataSource,
      tableOptions: {
        ...prevState.tableOptions,
        linesOrder: linesOrder,
        linesTotal: linesTotal,
        linesRatio: linesRatio,
        linesRatioN: linesRatioN,
        linesFinancial: linesFinancial,
        lineVertical: lineVertical,
        clickCallback: clickCallback,
      },
    }))
  }, [dataEvolutionReport, lineVertical])

  const clickCallback = (info, value, filters, pivotData) => {
    if (_.isEmpty(editFilter)) {
      setEditFilters(filters)
      const originElement = info.target.innerHTML
      const newElement = info.target

      newElement.innerHTML = `<input type=text value=${value} >`
      const inputElement = document.querySelector('input[type="text"]')

      inputElement.focus()

      inputElement.addEventListener('input', function (e) {
        inputValue = e.target.value
      })

      inputElement.addEventListener('blur', function () {
        newElement.innerHTML = originElement
        inputElement.removeEventListener('keypress', {})
        inputElement.removeEventListener('input', {})
        setEditFilters({})
        inputValue = null
      })

      inputElement.addEventListener('keypress', function (e) {
        if (e.key === 'Enter') {
          console.log(inputValue)
          handleEditFinancial({
            updatedFinancial: () =>
              updatedInitialAmountByFinancial({
                ...filters,
                period_id: periodId,
                initial_amount: inputValue,
                id_report: reportId,
                type_report: selectedProjection,
              }),
            onRefetch: onRefetch,
          })
          inputElement.removeEventListener('keypress', {})
          inputElement.removeEventListener('input', {})
          setEditFilters({})
        }
      })
    }
  }

  const handleCreate = ({ text, usersIds, idComment = null, setIsNewThread }) => {
    const dataa = {
      text,
      key: `${commentKey}-table-evolution`,
      module: commentKey,
      mentions: usersIds,
      ...(idComment && {
        parent: idComment,
      }),
    }
    setIsSaving(true)
    createComment(dataa)
      .then(() =>
        onRefetchComments().then(() => {
          message.success(t('FEEDBACK_SAVE_CHANGES_SUCCES'), 8)
          setIsSaving(false)
          setIsNewThread(false)
        }),
      )
      .catch((error) => {
        message.error(generateMessageError(error, 'FEEDBACK_SAVE_CHANGES_FAIL_MESSAGE'), 8)
        setIsSaving(false)
        setIsNewThread(false)
      })
  }
  const renderTable = () => {
    if (enabledPlaneTable) {
      return (
        <Spin spinning={loading}>
          <Dropdown
            trigger={['contextMenu']}
            overlay={
              <Menu>
                {GENERAL.OPTION_COMMENT.map((el) => (
                  <Menu.Item
                    key={el.key}
                    icon={<CommentOutlined />}
                    onClick={() => {
                      setViewComment(true)
                      setHasComment({ type: 'table', data: !hasComment.table })
                    }}
                  >
                    {t(el.label)}
                  </Menu.Item>
                ))}
              </Menu>
            }
          >
            <div style={{ width: '100%' }}>
              <PlaneTableUX
                renderers={Object.assign({}, PlaneTableRenderers)}
                data={dataSource}
                onChange={(s) => {
                  setSettings(s)
                  setHash(getHashTable(s, tabKey))
                  setShowTableqp(true)
                }}
                numberFormat={(val) =>
                  enableFormatNumber ? setFormatNumber(loggedUser, val) : val
                }
                vals={settings.default_value ? [settings.default_value] : ['amount']}
                cols={fields.columns}
                rows={['Linea de reporte']}
                aggregatorName={settings.default_format || formatBaseNumber}
                hiddenFromDragDrop={['amount', 'price', 'quantity']}
                hiddenFromAggregators={
                  dataSource[0] &&
                  dataSource[0].filter(
                    (el) => el !== 'amount' && el !== 'price' && el !== 'quantity',
                  )
                }
                tableFilter={{}}
                tableOptions={{
                  linesOrder: linesOrder,
                  linesTotal: linesTotal,
                  linesRatio: linesRatio,
                  linesRatioN: linesRatioN,
                  linesFinancial: linesFinancial,
                  lineVertical: lineVertical,
                  clickCallback: clickCallback,
                }}
                plotlyConfig={{
                  responsive: true,
                }}
                {...settings}
              />
            </div>
          </Dropdown>
        </Spin>
      )
    }
    if (enabledEvolutionTable) {
      return (
        <Spin spinning={loading}>
          <Dropdown
            trigger={['contextMenu']}
            overlay={
              <Menu>
                {GENERAL.OPTION_COMMENT.map((el) => (
                  <Menu.Item
                    key={el.key}
                    icon={<CommentOutlined />}
                    onClick={() => {
                      setViewComment(true)
                      setHasComment({ type: 'table', data: !hasComment.table })
                    }}
                  >
                    {t(el.label)}
                  </Menu.Item>
                ))}
              </Menu>
            }
          >
            <div style={{ width: '100%' }}>
              <PivotTableUX
                renderers={Object.assign({}, PivotTableRenderers)}
                data={dataSource}
                onChange={(s) => {
                  setSettings(s)
                  setHash(getHashTable(s, tabKey))
                  setShowTableqp(true)
                }}
                numberFormat={(val) =>
                  enableFormatNumber ? setFormatNumber(loggedUser, val) : val
                }
                vals={settings.default_value ? [settings.default_value] : ['amount']}
                cols={fields.columns}
                rows={['Linea de reporte']}
                aggregatorName={settings.default_format || formatBaseNumber}
                hiddenFromDragDrop={['amount', 'price', 'quantity']}
                hiddenFromAggregators={
                  dataSource[0] &&
                  dataSource[0].filter(
                    (el) => el !== 'amount' && el !== 'price' && el !== 'quantity',
                  )
                }
                tableFilter={{}}
                tableOptions={{
                  linesOrder: linesOrder,
                  linesTotal: linesTotal,
                  linesRatio: linesRatio,
                  linesRatioN: linesRatioN,
                  linesFinancial: linesFinancial,
                  lineVertical: lineVertical,
                  clickCallback: clickCallback,
                }}
                plotlyConfig={{
                  responsive: true,
                }}
                {...settings}
              />
            </div>
          </Dropdown>
        </Spin>
      )
    }

    return (
      <EvolutionTable
        loading={loading}
        dataSource={rows}
        periodTableColumns={periodTableColumns}
        setPeriodTableColumns={setPeriodTableColumns}
        periodTableSettings={periodTableSettings}
        filters={selectedFilters}
        selectedDates={selectedDates}
        selectedProjection={selectedProjection}
        tablePagination={tablePagination}
        lineVertical={lineVertical}
        currencyData={currencyData}
      />
    )
  }

  const renderCanSave = () => {
    const { data, tableOptions, ...rest } = settings
    return !_.isEmpty(rest) || (!_.isEmpty(rest) && !_.isEqual(defaultData, defaultSettings))
  }

  const handleEditName = (item) => {
    createLayout('reports', `${periodId}-${reportId}-montly_evolution`, item.name, {
      ...item,
      name: newName,
    })
      .then(() =>
        fetchLayoutList('reports', `${periodId}-${reportId}-montly_evolution`).then(() => {
          message.success(t('FEEDBACK_CHANGES_SAVED_SUCCESS'), 8)
          setShowEdit(false)
          setRowId(false)
        }),
      )
      .catch((error) => {
        setShowEdit(false)
        setRowId(false)
        notification.error({
          message: t('FEEDBACK_DEFAULT_ERROR'),
          description: generateMessageError(error),
          duration: 0,
        })
      })
  }

  const getData = () => {
    if (enabled) {
      return [getDataGraphByReport]
    }
    return [reportChartData]
  }

  const onDelete = (item, { ...props }) => {
    handleDelete({
      setIsLoading: setIsSaving,
      deleteLayout: () =>
        deleteLayout('reports', `${periodId}-${reportId}-montly_evolution`, item.name),
      onRefetch: () => fetchLayoutList('reports', `${periodId}-${reportId}-montly_evolution`),
      onClose: () => setIsSaving(false),
      ...props,
    })
  }

  const handleClickBase = (key) => {
    setSelectedProjection(key)
    setBaseSelect(key.id ? `${key.value}-${key.id}` : 'real')
    window.history.replaceState(
      null,
      '',
      `/analisis/${periodId}/reportesplika/${reportId}/${type}/${currencyData.id}/${tabKey}/${
        key.id ? `${key.value}-${key.id}` : key.value
      }${reportLine ? `?reportLine=${reportLine}` : ''}`,
    )
  }

  const handleClickVerticalLine = (key) => {
    setLineVertical(key)
    window.history.replaceState(
      null,
      '',
      `/analisis/${periodId}/reportesplika/${reportId}/${type}/${currencyData.id}/${tabKey}/${
        selectedProjection.id
          ? `${selectedProjection.value}-${selectedProjection.id}`
          : selectedProjection.value
      }?reportLine=${key}`,
    )
  }

  const getAlreadyExist = () => {
    if (table) {
      const dataHash = !isEqual(hash, table) && hash !== null ? hash : table
      const json = Buffer.from(dataHash, 'base64').toString()
      const dataTable = JSON.parse(json)
      const { columns, cols, aggregatorName, rows, default_value, vals, default_format } =
        dataTable.config
      const data = layoutList.values
        .filter((el) => !el.url_hash)
        .find((el) => {
          const { column_order, row_order, ...restProps } = el.config
          const dataConfig = {
            ...restProps,
            rows: getRowAuxName(restProps.rows, allDimensionsList),
            columns: getColsAuxName(restProps.columns, allDimensionsList),
          }
          return _.isEqual(
            {
              columns: columns ? columns : cols,
              rows,
              default_value: default_value ? default_value : vals[0],
              default_format: default_format
                ? default_format
                : DEFAULT_FORMAT_CREATE[aggregatorName],
            },
            dataConfig,
          )
        })

      if (data) {
        const { column_order, row_order, ...restProps } = data.config

        const filterData = {
          ...restProps,
          rows: getRowAuxName(restProps.rows, allDimensionsList),
          columns: getColsAuxName(restProps.columns, allDimensionsList),
        }

        return _.isEqual(
          {
            columns: columns ? columns : cols,
            rows,
            default_value: default_value ? default_value : vals[0],
            default_format: default_format ? default_format : DEFAULT_FORMAT_CREATE[aggregatorName],
          },
          filterData,
        )
      } else {
        return false
      }
    } else {
      return _.isEqual(defaultData, defaultSettings)
    }
  }

  const handleBeforeUnload = useCallback(() => {
    localStorage.removeItem('dataTable')
    setExist(false)
  }, [])

  return (
    <>
      <Prompt
        when={localStorage.getItem('dataTable')}
        message={(nextLocation) => {
          handleBeforeUnload()
          return true
        }}
      />
      <Row gutter={[12, 12]}>
        {!enabledEvolutionTable && (
          <Col span={24}>
            <ColumnsAndRowsSelections
              onRefresh={onRefetch}
              params={params}
              period_id={periodId}
              setPagination={setTablePagination}
            />
          </Col>
        )}
        <Col span={24}>
          <Space direction="horizontal">
            <SelectType.EvolutionSelect
              loading={loading}
              groupProjection={groupProjection}
              activeOptionTable={selectedProjection}
              setActiveByPeriodTable={handleClickBase}
              tabKey={tabKey}
            />
            <SelectType.VerticalAnalysisSelect
              loading={loading}
              groupLines={linesReport}
              selectedOptions={lineVertical}
              setSelectedOptions={handleClickVerticalLine}
            />
          </Space>
        </Col>
        <Col span={24} style={{ display: 'flex', justifyContent: 'center' }}>
          {showProgressBar && <ProgressBar isLoading={isProgressLoading} />}
        </Col>
        <Col span={24}>
          <TableActions
            setPeriodTableSettings={setPeriodTableSettings}
            periodTableSettings={periodTableSettings}
            onClick={() => {
              downloadEvolutionXLS(
                reportId,
                paramsDownload,
                t('REPORT_EVOLUTION_FILE_NAME', {
                  periodName: selectedPeriod.name,
                  date: moment().format('lll'),
                }),
              )
              sendUserDataToGTM(loggedUser, 'Análisis', 'Descargar evolución análisis', 'Descarga')
            }}
            onClickDownloadSpreadsheets={() => setShowModal(true)}
            onClickSaveFav={() => setShowPopover(true)}
            visibleFav={showPopover}
            onClickSave={() =>
              handleSave({
                setIsLoading: setIsSaving,
                createLayout: () => onCreate(),
                onRefetch: () =>
                  fetchLayoutList('reports', `${periodId}-${reportId}-montly_evolution`),
                onRefresh: onRefetchEvolution,
                onClose,
              })
            }
            onClickCancelSaveFav={onClose}
            setFavouriteName={setFavouriteName}
            favouriteName={favouriteName}
            isLoading={isSaving}
            hasFavourite={layoutList.values.filter((el) => !el.url_hash).length > 0}
            options={layoutList.values
              .filter((el) => !el.url_hash)
              .map((el) => {
                return { name: el.name, id: el.name, primary: el.primary }
              })}
            canSave={renderCanSave()}
            viewSelect={viewSelect}
            setViewSelect={(val) => {
              const aux = layoutList.values
                .filter((el) => !el.url_hash)
                .find((el) => el.name === val)
              const dataTable = {
                ...aux.config,
                hiddenFromDragDrop: ['amount', 'price', 'quantity'],
                cols:
                  getColsAuxName(aux.config.columns, allDimensionsList).length > 0
                    ? getColsAuxName(aux.config.columns, allDimensionsList)
                    : ['Fecha'],
                rows: getRowAuxName(aux.config.rows, allDimensionsList),
                aggregatorName: DEFAULT_FORMAT_SET[aux.config.default_format],
                vals: [aux.config.default_value],
              }
              getHashTable(dataTable, tabKey)
              setViewSelect(aux)
            }}
            alreadyExist={getAlreadyExist() || exist}
            layoutLoading={isLayoutLoading}
            setPrimary={(data) =>
              handleSavePrimary({
                setIsLoading: setIsSaving,
                createLayout: () => onSavePrimary(data),
                onRefetch: () =>
                  fetchLayoutList('reports', `${periodId}-${reportId}-montly_evolution`),
                onClose: () => setIsSaving(false),
              })
            }
            onClickDeleteFav={(name) =>
              handleDelete({
                setIsLoading: setIsSaving,
                deleteLayout: () =>
                  deleteLayout('reports', `${periodId}-${reportId}-montly_evolution`, name),
                onRefetch: () =>
                  fetchLayoutList('reports', `${periodId}-${reportId}-montly_evolution`),
                onClose: () => setIsSaving(false),
              })
            }
            showComments={
              viewComment ||
              dataComments.filter(
                (el) => el.key === `${commentKey}-table-evolution` && !el.resolved,
              ).length > 0
            }
            hasComment={hasComment}
            setHasComment={setHasComment}
            setViewComment={setViewComment}
            userDetail={loggedUser}
            settings={settings}
            setDataComments={setDataComments}
            dataComments={dataComments.filter(
              (el) => (el.key === `${commentKey}-table-evolution` && !el.resolved) || !el.text,
            )}
            onRefetchComments={onRefetchComments}
            loadingComments={loadingComments}
            onCommentCreate={(text, usersIds, idComment, setIsNewThread) =>
              handleCreate({ text, usersIds, idComment, setIsNewThread })
            }
            removeNewComment={removeNewComment}
            currencyData={currencyData}
            onClickEditNameFav={() => setShowModalEdit(true)}
            onClckPreferences={() => setShowPreferenceModal(true)}
          />
        </Col>
        <Col span={24}>
          {/* TODO: NEW FOR REVAMP TABLE */}
          {renderTable()}
        </Col>
        <Col span={24}>
          {!isLoadingGraphAndKpi && !isProgressLoading && (
            <ReportChart
              rows={dataEvolutionChart}
              lineId={lineId}
              selectedDates={selectedDates}
              setDataComments={setDataComments}
              dataComments={dataComments}
              onRefetchComments={onRefetchComments}
              loadingComments={loadingComments}
              commentKey={commentKey}
              currencyData={currencyData}
              dataChart={getData()}
            />
          )}
        </Col>
        <FavouriteEditModal
          visible={showModalEdit}
          onClose={() => setShowModalEdit(false)}
          dataSource={layoutList.values.filter((el) => !el.url_hash)}
          viewSelect={viewSelect}
          setIsSaving={setIsSaving}
          onSavePrimary={(item) => onSavePrimary(item)}
          onRefetch={() => fetchLayoutList('reports', `${periodId}-${reportId}-montly_evolution`)}
          handleDelete={(item) => {
            if (layoutList.values.filter((el) => !el.url_hash).length > 1 && item.primary) {
              const filterItems = layoutList.values.filter(
                (el) => el.name !== item.name && !el.url_hash,
              )
              const newItem = filterItems[filterItems.length - 1]
              onDelete(item, {
                onSetPrimary: () =>
                  createLayout(
                    'reports',
                    `${periodId}-${reportId}-montly_evolution`,
                    newItem.name,
                    {
                      ...newItem,
                      primary: true,
                    },
                  ),
                setViewSelect: () => setViewSelect(newItem),
              })
            } else if (layoutList.values.filter((el) => !el.url_hash).length === 1) {
              onDelete(item, {
                onRefetch: () =>
                  Promise.all([
                    fetchLayoutList('reports', `${periodId}-${reportId}-montly_evolution`),
                    onRefetchEvolution(),
                  ]),
                setSettings: () =>
                  setSettings({
                    ...settings,
                    vals: ['amount'],
                    cols: ['Fecha'],
                    rows: ['Linea de reporte'],
                    aggregatorName: 'Suma (Decimales)',
                  }),
              })
            } else {
              onDelete(item, {})
            }
          }}
          handleEditName={(item) => handleEditName(item)}
          showEdit={showEdit}
          setShowEdit={setShowEdit}
          rowId={rowId}
          setRowId={setRowId}
          newName={newName}
          setNewName={setNewName}
        />
        <DownloadModal
          title={INTEGRATIONS.KEYS.SPREADSHEETS_KEY}
          visible={showModal}
          onCancel={() => setShowModal(false)}
          defaultValue={loggedUser.folder_id}
          dataSpreadsheets={{
            type_load: 'report',
            params: {
              report_id: reportId,
              period_id: periodId,
            },
          }}
          sendUserDataToGTM={() =>
            sendUserDataToGTM(
              loggedUser,
              'Análisis',
              'Descargar evolución por spreadsheet análisis',
              'Descarga',
            )
          }
        />
        <PreferencesTableModal
          visible={showPreferenceModal}
          onClose={() => setShowPreferenceModal(false)}
          onRefresh={onRefetch}
          setShowPreferenceModal={setShowPreferenceModal}
          allDimensionsList={allDimensionsList}
        />
      </Row>
    </>
  )
}

const mapStateToProps = (state) => ({
  dataTableEvolution: reports.selectors.getReportDetail(state),
  loggedUser: login.selectors.getWhoAmI(state),
  reportStructure: reports.selectors.getReportStructure(state),

  // TODO: NEW ENDPOINTS FOR REVAMP TABLE
  dataEvolutionReport: reports.selectors.getDataEvolutionByReport(state),
  layoutList: control.selectors.getLayoutList(state),
  allDimensionsList: configuration.selectors.getAllDimensionsList(state),
  hasComment: configuration.selectors.getHasComment(state),
  getDataGraphByReport: reports.selectors.getDataGraphByReport(state),
  reportChartData: reports.selectors.getReportChartData(state),
})

const mapDispatchToProps = {
  downloadEvolutionXLS: reports.actions.downloadEvolutionXLS,
  createLayout: control.actions.createLayout,
  fetchLayoutList: control.actions.fetchLayoutList,
  fetchAllDimensions: configuration.actions.fetchAllDimensions,
  updatedInitialAmountByFinancial: reports.actions.updatedInitialAmountByFinancial,
  deleteLayout: control.actions.deleteLayout,
  setHasComment: configuration.actions.setHasComment,
  createComment: configuration.actions.createComment,
  removeNewComment: configuration.actions.removeNewComment,
}

export default connect(mapStateToProps, mapDispatchToProps)(Evolution)
